var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 28.2998V36.7999C40.5 38.9889 38.9262 40.8718 36.7563 41.1599C32.5829 41.714 28.3249 42 24 42C19.6751 42 15.4171 41.714 11.2437 41.1599C9.07379 40.8718 7.5 38.9888 7.5 36.7999V28.2998M40.5 28.2998C41.4438 27.4953 42 26.2778 42 24.9778V17.4114C42 15.2495 40.4642 13.3816 38.3261 13.0617C36.0753 12.7249 33.799 12.4663 31.5 12.2886M40.5 28.2998C40.1128 28.6299 39.6603 28.8905 39.1542 29.0588C34.3906 30.6425 29.2955 31.5 24 31.5C18.7046 31.5 13.6094 30.6425 8.84577 29.0587C8.33969 28.8905 7.88722 28.6299 7.5 28.2998M7.5 28.2998C6.55616 27.4952 6 26.2777 6 24.9777V17.4114C6 15.2495 7.53581 13.3816 9.67388 13.0617C11.9247 12.7249 14.201 12.4663 16.5 12.2886M31.5 12.2886V10.5C31.5 8.01472 29.4853 6 27 6H21C18.5147 6 16.5 8.01472 16.5 10.5V12.2886M31.5 12.2886C29.0251 12.0974 26.5239 12 24 12C21.4761 12 18.9749 12.0974 16.5 12.2886M24 25.5H24.015V25.515H24V25.5Z",
    stroke: "#FFEFEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ec0dd60c6bbf627109d5fecbfa75e13d.svg";
export { ForwardRef as ReactComponent };